module.exports = __webpack_public_path__ + "img/CHART_AREA.29f5e831.svg";